import { get } from 'lodash';

import { AutoComplete, Input, RemoteAutoComplete } from '@components/form';
import { required } from '@utils/validators';

export const stateEnum = [
  {
    id: 'OPEN',
    label: 'Otevřená'
  },
  {
    id: 'CLOSED',
    label: 'Uzavřená'
  },
  {
    id: 'PROCESSING',
    label: 'V řešení'
  }
];

export const delictStateEnum = [
  { id: 'CREATED', label: 'vytvořen' },
  { id: 'SOLVED', label: 'vyřešen' },
  { id: 'FORWARDED', label: 'postoupen' },
  { id: 'CANCELED', label: 'zrušen' }
];

export const delictResolutionEnum = [
  { id: 'REBUKE', label: 'Domluva' },
  { id: 'BNP', label: 'Blok na místě nezaplacený' },
  { id: 'BNZ', label: 'Pokutový blok' },
  { id: 'NOT_HAPPENED', label: 'Skutek se nestal' },
  { id: 'FORWARDED_SO', label: 'Předáno na SO' }
];

export const participantsTypeEnum = [
  { id: 'PERPETRATOR', label: 'pachatel' },
  { id: 'WITNESS', label: 'svědek' },
  { id: 'INJURED', label: 'poškozený' },
  { id: 'CHECKED', label: 'kontrolovaný' },
  { id: 'SUSPECT', label: 'podezřelý z trestného činu' },
  { id: 'ADDRESSEE', label: 'adresát' },
  { id: 'REPORTER', label: 'oznamovatel' },
  { id: 'OTHER', label: 'jiný' }
];

export const iszrIdentificationTypeEnum = [
  { id: 'ID_CARD', label: 'Občanský průkaz' },
  { id: 'PASSPORT', label: 'Pas' },
  { id: 'IR', label: 'Povolení k pobytu' },
  { id: 'OTHER', label: 'Jiný' }
];

export const identificationTypeEnum = [
  ...iszrIdentificationTypeEnum,
  { id: 'DRIVING_LICENCE', label: 'Řidičský průkaz' },
  { id: 'GUN_LICENCE', label: 'Zbrojní průkaz' }
];

export const eventHistoryActionEnum = [
  { id: 'CREATED', label: 'vytvořena' },
  { id: 'UPDATED', label: 'změnena' },
  { id: 'CLOSED', label: 'uzavřena' },
  { id: 'OPENED', label: 'otevřena' },
  { id: 'DELETED', label: 'smazána' },
  { id: 'FILE_CREATED', label: 'hlášení vytvořeno' },
  { id: 'FILE_UPDATED', label: 'hlášení aktualizováno' },
  { id: 'FILE_DELETED', label: 'hlášení smazáno' },
  { id: 'LOCKED', label: 'uzamčena' },
  { id: 'UNLOCKED', label: 'odemčena' }
];

export const eventHistoryCategoryEnum = [
  { id: 'EVENT', label: 'událost' },
  { id: 'REPORTERS', label: 'oznamovatel' },
  { id: 'PARTICIPANTS', label: 'účastníci' },
  { id: 'DELICTS', label: 'přestupky' },
  { id: 'DESCRIPTION', label: 'hlášení' },
  { id: 'FILES', label: 'soubory' },
  { id: 'NOTE', label: 'poznámka' },
  { id: 'PHOTOS', label: 'fotodokumentace' },
  { id: 'LOCK', label: 'odemčena/uzamčena' },
  { id: 'STATE', label: 'stav' }
];

export const eventHistorySourceEnum = [
  { id: 'WEB', label: 'Webová aplikace' },
  { id: 'MOBILE', label: 'Mobilní aplikace' }
];

export const pcrIdentificationTypeEnum = [
  { id: 'IDENTITY_CARD', label: 'občanský průkaz' },
  { id: 'PASSPORT_VIOLET', label: 'cestovní pas vydaný centrálně – fialový' },
  { id: 'PASSPORT_GREEN', label: 'cestovní pas vydaný regionálně – zelený' },
  { id: 'ARMS_LICENSE', label: 'zbrojní průkaz / zbrojní licence' }
];
export const participantsClassificationTypeEnum = [
  {
    id: 'PZS_DELIVERY',
    label: 'Rozhodnutí o dodání na PZS'
  },
  {
    id: 'PCR_DELIVERY',
    label: 'Osoba předvedena na PČR'
  },
  {
    id: 'MISSING',
    label: 'Osoba v pátrnání (hledná a pohřešovaná)'
  },
  {
    id: 'OFFENDER',
    label: 'Pachatel T.Č.'
  },
  {
    id: 'COERCIVE_MEASURES',
    label: 'Použití donucovacích prostředků'
  }
];

export const recordCase = {
  component: RemoteAutoComplete,
  name: 'recordCase',
  label: 'Věc spisu',
  url: 'api/common/sps/record/rcase',
  filterActive: true,
  labelFunction: o => get(o, 'name'),
  valueFunction: o => get(o, 'name'),
  validate: [required],
  firstOnly: true
};

const fileId = {
  component: AutoComplete,
  name: 'fileId',
  label: 'Inicializační dokument',
  labelFunction: o => get(o, 'name'),
  valueFunction: o => get(o, 'id'),
  validate: [required],
  firstOnly: true,
  items: 'fileId'
};

const documentMark = {
  component: RemoteAutoComplete,
  name: 'documentMark',
  label: 'Značka dokumentu',
  url: 'api/common/sps/document/marks',
  filterActive: true,
  labelFunction: o => get(o, 'name'),
  valueFunction: o => get(o, 'name'),
  validate: [required]
};

const documentCase = {
  component: RemoteAutoComplete,
  name: 'documentCase',
  label: 'Věc dokumentu',
  url: 'api/common/sps/document/dcase',
  filterActive: true,
  labelFunction: o => get(o, 'name'),
  valueFunction: o => get(o, 'name'),
  validate: [required]
};

const documentCaseGinis = {
  component: Input,
  name: 'documentCase',
  label: 'Název',
  type: 'text',
  validate: [required]
};

const documentSymbol = {
  component: RemoteAutoComplete,
  name: 'documentSymbol',
  label: 'Spisový znak dokumentu',
  url: 'api/common/sps/document/symbols',
  filterActive: true,
  labelFunction: o => get(o, 'name'),
  valueFunction: o => get(o, 'code'),
  validate: [required],
  lazy: true
};

const documentType = {
  component: RemoteAutoComplete,
  name: 'documentType',
  label: 'Spisový typ dokumentu',
  url: 'api/common/sps/document/types',
  filterActive: true,
  labelFunction: o => get(o, 'name'),
  valueFunction: o => get(o, 'typeId'),
  validate: [required]
};

const ginisLabels = {
  fileId: 'Inicializační dokument',
  documentSymbol: 'Spisový znak',
  documentType: 'Typ dokumentu'
};

const getGinisLabel = (field: any) => {
  return {
    ...field,
    label: get(ginisLabels, field.name, field.label)
  };
};

export const spsFields = {
  ginis: [fileId, documentSymbol, documentCaseGinis, documentType].map(f => getGinisLabel(f)),
  geosps: [recordCase, fileId, documentMark, documentCase, documentSymbol]
};



// WEBPACK FOOTER //
// ./src/modules/events/_eventsEnums.ts